import React, { Component } from 'react';
import BsyTurnPage from "../BsyTurnPage";
import './index.css'
import BsyDialog from "../BsyDialog";
import BsySelect from "../BsySelect";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import { dayjsUtils } from '../../utils/dayjsUtils';
import { BsyUtils } from '../../utils/Utils';

class BsyWebhookLogPane extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            skip: 0,
            day: 0,
            count: 0,
            limit: 20,
            status: -1,
        }
    }

    items = [{
        text: React.language("all"),
        value: -2,
        selected: true
    }, {
        text: React.language("data.api.log.fail"),
        value: -1,
        selected: false
    }, {
        text: React.language("pending.log"),
        value: 1,
        selected: false
    }, {
        text: React.language("data.api.log.success"),
        value: 2,
        selected: false
    }, {
        text: React.language("abandon.log"),
        value: 3,
        selected: false
    }]

    componentDidMount() {
        this.loadWebHookLog(this.state.status)
    }

    statusSwitch = (d) => {
        let text = ""
        let color = ""
        switch (d) {
            case -1:
                text = React.language('fail')
                color = "var(--bsy-base-error-color)"
                break;
            case -2:
                text = React.language('fail')
                color = "var(--bsy-base-error-color)"
                break;
            case 1:
                text = React.language('pending.status')
                color = "#666666"
                break;
            case 2:
                text = React.language('success')
                color = "#4ACC8C"
                break;
            case 3:
                text = React.language('data.api.push.discard')
                color = "#666666"
                break;
            default:
        }
        return {
            text: text,
            color: color
        }
    }

    detailView = (d) => {
        return () => {
            BsyDialog({
                title: React.language("data.api.log"),
                height: 540,
                width: 720,
                noFooter: true,
                onContentCreate: () => {
                    return <div className="logDetail">
                        <div className="detailItem">
                            <div className="detailTitle"><span>{React.language('push.content')}</span></div>
                            <div className="detailCont"><span>{JSON.stringify(d.event_data)}</span></div>
                        </div>
                        <div className="detailItem">
                            <div className="detailTitle"><span>{React.language('data.api.code')}</span></div>
                            <div className="detailCont"><span>{d.status_code ? d.status_code : "——"}</span></div>
                        </div>
                        <div className="detailItem">
                            <div className="detailTitle"><span>{React.language('data.api.logTime')}</span></div>
                            <div className="detailCont"><span>{
                                BsyUtils.date2Str(dayjsUtils.timeToTZ(d.last_time), "yyyy-MM-dd HH:mm:ss")
                            }</span></div>
                        </div>
                        {d.status !== 2 && <div className="detailItem">
                            <div className="detailTitle"><span>{React.language('fail.detail')}</span></div>
                            <div className="detailCont"><span>{d.err}</span></div>
                        </div>}
                        {(d.status === -2 || d.status === -1) && this.props.openapi && <div className="detailItem" style={{ "border": "none", "display": "flex", "justify-content": "end" }}>
                            <div className="detailBtn" onClick={this.againPush(d)}><span>{React.language('data.api.push.again')}</span></div>
                        </div>}
                    </div>
                }
            })
        }
    }

    againPush = (d) => {
        return (event) => {
            // const e = event.currentTarget;
            window.FX.Msg.alert({
                type: "query",
                title: React.language("retry.webhook.tip"),
                text4Ok: React.language("ok"),
                onOk: function () {
                    React.axios("/webhook/retry", {
                        id: d.pushid,
                        event_id: d.event_id
                    }).then((res) => {
                        tipAlert({
                            type: 'success',
                            msg: React.language('retry.webhook.tip1')
                        })
                        // e.parentNode.remove()
                    })
                }
            });
        }
    }



    loadWebHookLog = (s) => {
        const { id } = this.props;
        const { skip, limit } = this.state;
        let params = {};
        if (s === -2 || !s) {
            params = { "id": id, "skip": skip * limit, "limit": limit };
        } else {
            params = { "id": id, "status": s, "skip": skip * limit, "limit": limit };
        }

        React.axios("/webhook/loginfo", {
            ...params
        }).then((res) => {
            this.setState({
                list: res.data.data.list,
                day: res.data.data.day,
                count: res.data.data.count
            })
        })
    }

    skipChange = (e) => {
        this.setState({
            skip: e
        }, () => {
            this.loadWebHookLog(this.state.status)
        })
    }

    listLimitChange = (e) => {
        this.setState({
            limit: e
        }, () => {
            this.loadWebHookLog(this.state.status)
        })
    }

    get_status_value = (e) => {
        this.setState({
            status: e,
            skip: 0
        }, () => {
            this.loadWebHookLog(e);
        })
    }

    render() {
        const { list, day, count, skip, limit, status } = this.state;
        return (
            <div className="webhook-log-pane">
                <div className="webhook-log-body">
                    <div className="webhook-log-cont">
                        <div className="logType">
                            <div className="logTitle"><span>{React.language('push.log.type')}</span></div>
                            <div className="typeSwitch">
                                <BsySelect
                                    allowBlank={false}
                                    searchable={false}
                                    minWidth={350} onStopEdit={this.get_status_value} value={status} items={this.items} />
                                <div className="log-day">{React.language('data.api.logTip.day', { day: day })}</div>
                            </div>
                        </div>
                        <div className="logging">
                            <div className="refreshBtn" onClick={() => {
                                this.loadWebHookLog(this.state.status)
                            }}>
                                <i className="icon-webhook-refresh" />
                                <span>{React.language('refresh')}</span>
                            </div>
                            <div className="logTitle"><span>{React.language('push.logging')}</span></div>
                            <div className="logTable">
                                <div className="logTableHeader">
                                    <div className="header-item">{React.language('data.api.logTime')}</div>
                                    <div className="header-item" style={{ width: "30%" }}>{React.language('data.api.logUrl')}</div>
                                    <div className="header-item">{React.language('push.event')}</div>
                                    <div className="header-item" style={{ width: "15%" }}>{React.language('data.api.logResult')}</div>
                                    <div className="header-item" style={{ width: "15%" }}>{React.language('data.api.logDetail')}</div>
                                </div>
                                <div className="logTableBody">
                                    {
                                        list.map((val) => {
                                            let statusText = this.statusSwitch(val.status);
                                            return <div className="body-line">
                                                <div className="body-item">{BsyUtils.date2Str(dayjsUtils.timeToTZ(val.last_time), "yyyy-MM-dd HH:mm:ss")}</div>
                                                <div className="body-item" style={{ width: "30%" }}>{val.url}</div>
                                                <div className="body-item">{val.type}</div>
                                                <div className="body-item" style={{ color: statusText.color, width: "15%" }}>{statusText.text}</div>
                                                <div className="body-item btn" style={{ width: "15%" }} onClick={this.detailView(val)}>{React.language('view.detail')}</div>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="webhook-log-page">
                        <BsyTurnPage skipChange={this.skipChange} listLimitChange={this.listLimitChange} limit={limit} skip={skip} count={count} />
                    </div>
                </div>
            </div>
        );
    }
}

export default BsyWebhookLogPane;